import { ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '4xl' | '7xl' | 'full';
  className?: string;
}

function PageContainer({ children, maxWidth = '4xl', className = '' }: PageContainerProps) {
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '4xl': 'max-w-4xl',
    '7xl': 'max-w-7xl',
    full: '',
  };

  const maxWidthClass = maxWidthClasses[maxWidth];

  return (
    <div className={`container mx-auto px-4 py-8 ${maxWidthClass} ${className}`.trim()}>
      {children}
    </div>
  );
}

export { PageContainer };
